export default {"src":"/_next/static/media/brand-installation.da87f0ec.svg","height":46,"width":46};